<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <span :class="{'loading-card' : loading.card}"><strong>Riwayat Deposit</strong></span>
          </CCardHeader>
          <CCardBody class="p-0">
            <div class="table-responsive" :class="{'loading-card' : loading.card}">
              <table class="table table-sm table-bordered table-hover text-nowrap mb-0" style="font-size:14px;">
                <thead>
                  <tr class="table-secondary">
                      <th class="text-center">Tanggal</th>
                      <th>ID</th>
                      <th>Pembayaran</th>
                      <th>Jml. Credit</th>
                      <th>Nominal Transfer</th>
                      <th>Waktu Expired</th>
                      <th>Status</th>
                      <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody v-if="deposit.length > 0">
                  <tr v-for="(item) in deposit" :key="item.id">
                      <td class="text-center">{{ item.created_at }}<br>{{ item.updated_at }}</td>
                      <td>#{{ item.id }}</td>
                      <td><b>{{ item.payment.payment_name }}</b><br>{{ item.payment_number }}</td>
                      <td>{{ item.credit }}</td>
                      <td>Rp {{ item.nominal_transfer | rupiah }}</td>
                      <td>{{ item.expired_time }}</td>
                      <td>
                        <CBadge color="warning" v-if="item.status == 'WAITING'">Menunggu</CBadge>
                        <CBadge color="success" v-else-if="item.status == 'SUCCESS'">Berhasil</CBadge>
                        <CBadge color="danger" v-else-if="item.status == 'EXPIRED'">Expired</CBadge>
                      </td>
                      <td class="text-center">
                        <router-link :to="'/history/deposit/'+item.id" class="btn btn-primary btn-sm" style="font-size:11px;">
                          Detail
                        </router-link>
                      </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                      <td colspan="7" class="text-center"><small><i>Data tidak ditemukan</i></small></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import $axios from './../../../api.js'
export default {
  name: 'history.depost.data',
  data(){
    return {
      alert:{
        show: false,
        content: ''
      },
      loading: {
        submit: false,
        card: true
      },
      deposit: [],
    }
  },
  created(){
    
  },
  computed:{
    ...mapState(['setting','errors'])
  },
  methods:{
    getDeposit(){
      $axios.get('/history/deposit')
      .then((response) => {
        this.loading.card = false
        this.deposit = response.data.data
      }).catch((error) => {
        this.loading.card = false
      })
    },
    // submit(){
    //   this.loading.submit = true
    //   this.$store.commit('CLEAR_ERRORS')
    //   this.alert = {
    //         show: false,
    //         content: ''
    //       }
    //   $axios.post('/deposit', this.data)
    //   .then((response) => {
    //     this.loading.submit = false
    //   }).catch((error) => {
    //     this.loading.submit = false
    //     if (error.response.status == 422) {
    //       this.$store.commit('SET_ERRORS', error.response.data.errors, { root: true })
    //     }else{
    //       this.alert = {
    //         show: true,
    //         content: error.response.data.message
    //       }
    //     }
    //   })
    // }
  },
  mounted(){
    
    this.getDeposit()
  }
}
</script>
